import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '@jumbo/components/PageComponents/PageLoader';

const CustomerVoice = () => {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${match.url}`} component={lazy(() => import('./CustomerVoice'))} />

        <Route component={lazy(() => import('../../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default CustomerVoice;
